import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import DisplayApp from './display/DisplayApp';

// Legacy iOS Safari (<=12) lacks ResizeObserver; provide a safe no-op to avoid boot crashes.
if (typeof window !== 'undefined' && typeof window.ResizeObserver === 'undefined') {
  window.ResizeObserver = class {
    constructor(callback: ResizeObserverCallback) {
      if (typeof callback === 'function') {
        requestAnimationFrame(() => callback([], this as unknown as ResizeObserver));
      }
    }
    observe() {}
    unobserve() {}
    disconnect() {}
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/display" element={<DisplayApp />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// Optional: Measure performance
reportWebVitals(console.log);

export {}; // Explicitly mark as module for --isolatedModules
